<template v-html="filteredUnsafeString">
  <div
    class="fluid-container alpha-main-container"
    ref="PortfolioReport"
    id="PortfolioReport"
    v-if="tab!=='pdf'"
  >
    <div class="row">
      <div class="col-sm-8">
        <h1 class="text-left alphaheading">PORTFOLIO REPORT</h1>
        <button v-if="(isBrokerUser==false || isBrokerGuest == true) && isMSIUser == false" class="alpha-btn" @click="generatePdf">Download Report</button>
      </div>
      <div class="col-sm-4">
        <div class="text-right" data-html2canvas-ignore="true">
          <button class="alpha-btn" @click="newReport" v-if="isBrokerUser==false || isBrokerAdminUser==true || isBrokerGuest == true">Generate New</button>
        </div>
      </div>
    </div>
    <div class="row inputrow">
      <div class="col-sm-12">
        <p>PortfolioSmith makes it easy to diagnose your stock ideas and see if they earn a pass, neutral or fail score for the Ratings and other critical technical and fundamental factors. You can access it anytime online to significantly speed up your investing research, without cutting corners on quality. In addition, we also recommend good quality stocks to buy.</p>
      </div>
    </div>

    <!--ONLY FOR WEB -->
    <div class="row tabs-block">
      <TabBar :tab="tab" :is_premium="is_premium" :isBrokerUser="isBrokerUser" :isBrokerGuest="isBrokerGuest"></TabBar>
      <!-- Tab panes -->
      <div
        class="tab-content alphatable"
        role="tabpanel"
        :id="'report-panel-' + tab"
        :aria-labelledby="'report-tab-' + tab"
      >
        <TradingAnalysis
          :TradingAnalysisComments="TradingAnalysisComments"
          :TradingAnalysisScorecard="TradingAnalysisScorecard"
          :TradingAnalysisTotalScore="TradingAnalysisTotalScore"
          :overallComment="overallComment"
          v-if="(tab==='TradingAnalysis'|| tab==='pdf') && is_premium==1 && showTradingAnalysisData===true && (isBrokerUser==false || isBrokerGuest)"
        ></TradingAnalysis>
        <TradingAnalysisBlurred
          v-if="(tab==='TradingAnalysis'|| tab==='pdf') && is_premium==0  && (isBrokerUser==false || isBrokerGuest)"
        ></TradingAnalysisBlurred>
        <Portfolio
          :portfolioData="portfolioData"
          :rankingLastRow="rankingLastRow"
          v-else-if="tab==='Portfolio' || tab==='pdf'"
        ></Portfolio>
        <Ratings
          :portfolioData="portfolioData"
          :rankingLastRow="rankingLastRow"
          v-else-if="tab==='rating'"
        ></Ratings>
        <!-- <MarketSmith :portfolioData="portfolioData" :rankingLastRow="rankingLastRow" v-else-if="tab==='marketsmith'"></MarketSmith> -->
        <Sector
          :imgPath="imgPath + 'Sector-Blurred.jpg'"
          :is_premium="is_premium"
          :portfolioData="portfolioData"
          :rankingLastRow="rankingLastRow"
          :sectorBreakdown="sectorBreakdown"
          :sectorLarge="sectorLarge"
          :sectorMid="sectorMid"
          :sectorSmall="sectorSmall"
          :plotPieData="plotPieData"
          :plotBarData="plotBarData"
          :barData="barData"
          :chartData="chartData"
          :noDataMsg="noDataMsg"
          :initCashPct="initCashPct"
          v-else-if="tab==='sector'"
        ></Sector>
        <Fundamentals
          :portfolioData="portfolioData"
          :rankingLastRow="rankingLastRow"
          :valuationEstimates="valuationEstimates"
          :isBrokerUser="isBrokerUser"
          :is_premium="is_premium"
          v-else-if="tab==='growth'"
        ></Fundamentals>
        <Performance
          :imgPath="imgPath + 'Performance-Blurred.jpg'"
          :is_premium="is_premium"
          :transactionData="transactionAnalysis"
          :portfolioData="portfolioData"
          :quarterlyReturns="quarterlyReturns"
          :annualReport="annualReport"
          :returnDistribution="returnDistribution"
          :rankingLastRow="rankingLastRow"
          :reportData="reportData"
          :bankingRow="bankingRow"
          :isBrokerUser="isBrokerUser"
          v-else-if="tab==='performance'"
        ></Performance>
        <Recommendations
          :imgPath="imgPath + 'Recommendation-Blurred.png'"
          :is_premium="is_premium"
          :portfolioData="portfolioData"
          :recommData="recommData"
          v-else-if="tab==='recommendations'"
        ></Recommendations>
        <ExistingRestructured
	  :imgPath="imgPath + 'Existing-Blurred.png'"
          :is_premium="is_premium"
          :portfolioData="portfolioData"
          :plotPieData="plotPieData"
          :plotPieDataForModel="plotPieDataForModel"
          :plotPieDataForTop5User="plotPieDataForTop5User"
          :plotPieDataForTop5Model="plotPieDataForTop5Model"
          :plotBarData="plotBarData"
          :plotBarDataForModel="plotBarDataForModel"
          :noDataMsg="noDataMsg"
          :chartData="chartData"
          :chartDataForTop5User="chartDataForTop5User"
          :chartDataForTop5Model="chartDataForTop5Model"
          :chartDataForModel="chartDataForModel"
          :barData="barData"
          :barOptions="barOptions"
          :barDataForModel="barDataForModel"
          :barOptionsForModel="barOptionsForModel"
          :stackedBarDataForInit="stackedBarDataForInit"
          :stackedBarOptionsForInit="stackedBarOptionsForInit"
          :stackedBarDataForFinal="stackedBarDataForFinal"
          :stackedBarOptionsForFinal="stackedBarOptionsForFinal"
          v-else-if="tab==='exisitvsrestruct'"
        ></ExistingRestructured>
      </div>
    </div>
  </div>
  <!-- PDF HTML START -->
  <div v-else-if="tab=='pdf'">
    <PDF
      ref="PDF"
      :imgPath="imgPath"
      :is_premium="is_premium"
      :transactionData="transactionAnalysis"
      :portfolioData="portfolioData"
      :reportData="reportData"
      :rankingLastRow="rankingLastRow"
      :sectorBreakdown="sectorBreakdown"
      :sectorLarge="sectorLarge"
      :sectorMid="sectorMid"
      :sectorSmall="sectorSmall"
      :recommData="recommData"
      :date="date"
      :pdfDate="pdfDate"
      :loader="loader"
      :client="client"
      :jmUser="jmUser"
      :brokerOrModelForRecomm="brokerOrModelForRecomm"
      :brokerOrModelForPortfolio="brokerOrModelForPortfolio"
      :plotPieData="plotPieData"
      :plotPieDataForModel="plotPieDataForModel"
      :plotPieDataForTop5User="plotPieDataForTop5User"
      :plotPieDataForTop5Model="plotPieDataForTop5Model"
      :plotBarData="plotBarData"
      :plotBarDataForModel="plotBarDataForModel"
      :noDataMsg="noDataMsg"
      :chartData="chartData"
      :chartDataForTop5User="chartDataForTop5User"
      :chartDataForTop5Model="chartDataForTop5Model"
      :chartDataForModel="chartDataForModel"
      :barData="barData"
      :barOptions="barOptions"
      :barDataForModel="barDataForModel"
      :barOptionsForModel="barOptionsForModel"
      :arUser="arUser"
      :bankingRow="bankingRow"
      :initCashPct="initCashPct"
      :stackedBarDataForInit="stackedBarDataForInit"
      :stackedBarOptionsForInit="stackedBarOptionsForInit"
      :stackedBarDataForFinal="stackedBarDataForFinal"
      :stackedBarOptionsForFinal="stackedBarOptionsForFinal"
      :quarterlyReturns="quarterlyReturns"
      :annualReport="annualReport"
      :TradingAnalysisComments="TradingAnalysisComments"
      :TradingAnalysisScorecard="TradingAnalysisScorecard"
      :TradingAnalysisTotalScore="TradingAnalysisTotalScore"
      :overallComment="overallComment"
      :isBrokerUser="isBrokerUser"
      :isBrokerGuest="isBrokerGuest"
      :returnDistribution="returnDistribution"
      :isBrokerAdminUser="isBrokerAdminUser"
      :valuationEstimates="valuationEstimates"
      :isMSIUser="isMSIUser"
    ></PDF>
  </div>
  <!-- PDF HTML END -->
</template>

<script>
import _ from "lodash";
import { mapActions, mapState, mapGetters } from "vuex";

import TabBar from "./Report/TabBar.vue";
import Portfolio from "./Report/Portfolio.vue";
import Ratings from "./Report/Ratings.vue";
import Sector from "./Report/Sector.vue";
import Fundamentals from "./Report/Fundamentals.vue";
import Performance from "./Report/Performance.vue";
import Recommendations from "./Report/Recommendations.vue";
import ExistingRestructured from "./Report/ExistingRestructured.vue";
import PDF from "./Report/PDF.vue";
import TradingAnalysis from "./Report/TradingAnalysis.vue";
import TradingAnalysisBlurred from "./Report/TradingAnalysisBlurred";
// import PieChart from "./PieChart.js";
// import BarChart from "./BarChart.js";
// import StackedBarChart from "./StackedBarChart.js";
// import html2pdf from "html2pdf.js";
// import { isTokenValid } from "../utils/util";
// import moment from "moment";

export default {
  name: "portfolio",
  components: {
    TabBar,
    TradingAnalysis,
    TradingAnalysisBlurred,
    Portfolio,
    Ratings,
    Sector,
    Fundamentals,
    Performance,
    Recommendations,
    ExistingRestructured,
    PDF
  },
  props: ["alphaScopeData", "transactionData", "is_premium", "imgPath"],

  data() {
    return {
      //Can set data here
      //Can set data here
      portfolioData: {},
      valuationEstimates:{},
      showTradingAnalysisData:false,
      rankingLastRow: {},
      returnDistribution: {},
      annualReport: {},
      reportData: {},
      sectorData: {},
      sectorBreakdown: {},
      quarterlyReturns: {},
      sectorLarge: {},
      sectorMid: {},
      sectorSmall: {},
      validPortfolio: {},
      recommData: null,
      loaded: false,
      limit: 10,
      date: new Date(),
      pdfDate: new Date(),
      loader: "",
      client: "",
      jmUser: false,
      arUser: false,
      brokerOrModelForRecomm: "",
      brokerOrModelForPortfolio: "",
      plotPieData: false,
      plotPieDataForModel: false,
      plotPieDataForTop5User: false,
      plotPieDataForTop5Model: false,
      plotBarData: false,
      plotBarDataForModel: false,
      noDataMsg: "No Data Available",
      sessionIdleErrorMsg: "Session Expired. Please Login Again",
      bankingRow: false,
      initCashPct: 0,
      finalCashPct: 0,
      isBrokerUser:false,
      isBrokerAdminUser:false,
      isBrokerGuest: false,
      isMSIUser: false,

      //Pie Charts Data
      chartData: {
        labels: ["Large", "Mid", "Small"],
        datasets: [
          {
            //label: "Breakdown by M'cap",
            backgroundColor: ["#41B883", "#E46651", "#00D8FF"],
            data: [0, 0, 0]
          }
        ]
      },

      chartDataForTop5User: {
        labels: "",
        datasets: [
          {
            //label: "Top 5 Sector Allocation for Existing Portfolio",
            backgroundColor: [
              "#41B883",
              "#E46651",
              "#00D8FF",
              "#aaffc3",
              "#e6beff"
            ],
            data: [0, 0, 0, 0, 0]
          }
        ]
      },

      chartDataForTop5Model: {
        labels: "",
        datasets: [
          {
            //label: "Top 5 Sector Allocation for Model Portfolio",
            backgroundColor: [
              "#41B883",
              "#E46651",
              "#00D8FF",
              "#aaffc3",
              "#e6beff"
            ],
            data: [0, 0, 0, 0, 0]
          }
        ]
      },

      chartDataForModel: {
        labels: ["Large", "Mid", "Small"],
        datasets: [
          {
            //label: "Breakdown by M'Cap for Model Portfolio",
            backgroundColor: ["#41B883", "#E46651", "#00D8FF"],
            data: [0, 0, 0]
          }
        ]
      },

      //Bar Charts
      barData: {
        labels: "",
        datasets: [
          {
            //label: "Top 10 holdings for Existing Portfolio",
            backgroundColor: [
              "#fabebe",
              "#ffd8b1",
              "#a9a9a9",
              "#911eb4",
              "#4363d8",
              "#42d4f4",
              "#bfef45",
              "#e6beff",
              "#aaffc3",
              "#469990"
            ],
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          }
        ]
      },
      barOptions: null,

      barDataForModel: {
        labels: "",
        datasets: [
          {
            //label: "Top 10 holdings for Model Portfolio",
            backgroundColor: [
              "#fabebe",
              "#ffd8b1",
              "#a9a9a9",
              "#911eb4",
              "#4363d8",
              "#42d4f4",
              "#bfef45",
              "#e6beff",
              "#aaffc3",
              "#469990"
            ],
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          }
        ]
      },
      barOptionsForModel: null,

      // Stacked Bar Charts
      stackedBarDataForInit: {
        labels: ["Existing"],
        datasets: [
          {
            data: [0],
            label: ["Cash"],
            backgroundColor: "rgba(163,103,126,1)",
            hoverBackgroundColor: "rgba(140,85,100,1)"
          },
          {
            data: [0],
            label: ["Equity"],
            backgroundColor: "rgba(63,203,226,1)",
            hoverBackgroundColor: "rgba(46,185,235,1)"
          }
        ]
      },
      stackedBarOptionsForInit: null,

      stackedBarDataForFinal: {
        labels: ["Model"],
        datasets: [
          {
            data: [0],
            label: ["Cash"],
            backgroundColor: "rgba(163,103,126,1)",
            hoverBackgroundColor: "rgba(140,85,100,1)"
          },
          {
            data: [0],
            label: ["Equity"],
            backgroundColor: "rgba(63,203,226,1)",
            hoverBackgroundColor: "rgba(46,185,235,1)"
          }
        ]
      },
      stackedBarOptionsForFinal: null
    };
  },

  beforeCreate: function() {
    if (
      localStorage.getItem("access_token") == null &&
      this.$session.get("access_token") == ""
    ) {
      this.$router.push({
        name: "Logout"
      });
    }
  },

  computed: {
    filteredUnsafeString() {
      return this.customFilter(this.unsafeString);
    },
    ...mapGetters("portfolioreport", {
      tab: "tab"
    }),
    ...mapGetters("addholdings", {
      portfolio: "portfolio"
    }),
    userData () {
		return this.$store.state.authentication.user;
	  },
  },

  mounted() {
    try {
      this.validPortfolio = this.alphaScopeData[0];
      this.isBrokerUser=this.userData.isBrokerUser;
      this.isBrokerAdminUser= this.userData.isBrokerAdminUser;
      this.isBrokerGuest = this.userData.userType == 3 ? true : false
      this.isMSIUser = localStorage.getItem('isMSIUser') == 'true' ? true : false
    } catch (exception) {
      this.validPortfolio = null;
    }

    if (this.validPortfolio) {
      this.client = this.isBrokerUser==true && !this.isBrokerGuest?this.userData.isBrokerAdminUser?localStorage.getItem("arClientName"):this.userData.name:""//localStorage.getItem("client")==="undefined"?"":localStorage.getItem("client");
      if (
        localStorage.getItem("user") === "jmfinancial" ||
        localStorage.getItem("broker_id") == 1
      ) {
        this.jmUser = true;
      }
      if (
        localStorage.getItem("user") === "anandrathi" ||
        localStorage.getItem("broker_id") == 10
      ) {
        this.arUser = false;
      }
      if(this.is_premium==1){
      this.TradingAnalysisComments = this.alphaScopeData[0]["trading_analysis_comments"];
      this.TradingAnalysisScorecard = this.alphaScopeData[0]["trading_analysis_scorecard"];
      this.TradingAnalysisTotalScore = this.alphaScopeData[0]["trading_analysis_total_score"];
      this.overallComment=this.alphaScopeData[0]["Welcome comment"];
      this.showTradingAnalysisData = true;
      this.portfolioData = this.alphaScopeData[0]["user_portfolio"];
      this.valuationEstimates = this.alphaScopeData[0]["valuation_estimates"];
      this.rankingLastRow = this.alphaScopeData[0]["user_portfolio_ranking"];
      this.sectorData = this.alphaScopeData[0]["sector_diversification"];
      this.sectorBreakdown = this.alphaScopeData[0]["sector_breakdown"];
      this.transactionAnalysis = this.alphaScopeData[0]["transaction_analysis"];
      this.sectorLarge = this.sectorData["Large"];
      this.sectorMid = this.sectorData["Mid"];
      this.sectorSmall = this.sectorData["Small"];
      this.recommData = this.alphaScopeData[0]["recommendations"];
      this.sectorDataForModel = this.alphaScopeData[0]["rec_sector_div"][
        "Non_cash_weightage"
      ];
      }
      else{
        this.TradingAnalysisComments = this.alphaScopeData[0]["trading_analysis_comments"];
        this.TradingAnalysisScorecard = this.alphaScopeData[0]["trading_analysis_scorecard"];
        this.TradingAnalysisTotalScore = this.alphaScopeData[0]["trading_analysis_total_score"];
        this.overallComment=this.alphaScopeData[0]["Welcome comment"];
	      this.portfolioData = this.alphaScopeData[0]["user_portfolio"];
        this.valuationEstimates = this.alphaScopeData[0]["valuation_estimates"];
        this.rankingLastRow = this.alphaScopeData[0]["user_portfolio_ranking"];
        this.sectorData = this.alphaScopeData[0]["sector_diversification"];
        this.sectorBreakdown = this.alphaScopeData[0]["sector_breakdown"];
        this.transactionAnalysis = this.alphaScopeData[0]["transaction_analysis"];
        this.sectorLarge = this.sectorData["Large"];
        this.sectorMid = this.sectorData["Mid"];
        this.sectorSmall = this.sectorData["Small"];
        // this.recommData = this.alphaScopeData[0]["recommendations"];
        // this.sectorDataForModel = this.alphaScopeData[0]["rec_sector_div"][
        //   "Non_cash_weightage"
        // ];
	      this.showTradingAnalysisData = false;

      }
      if (this.alphaScopeData[0]["portfolio_report"]){
        this.reportData = this.alphaScopeData[0]["portfolio_report"];
      }
      if (this.alphaScopeData[0]["Portfolio_annual_report"]){
        this.annualReport = this.alphaScopeData[0]["Portfolio_annual_report"];
      }
      if (this.alphaScopeData[0]["Portfolio_annual_report"]){
        this.returnDistribution = this.alphaScopeData[0]["return_distribution"];
      }
      if (this.alphaScopeData[0]["Portfolio_quarterly_returns"]){
        this.quarterlyReturns = this.alphaScopeData[0]["Portfolio_quarterly_returns"];
      }
      // Broker or Model
      // this.brokerOrModelForRecomm = localStorage.getItem(
      //   "BrokerOrModelForRecomm"
      // );
      this.brokerOrModelForRecomm = this.portfolio.BrokerOrModelForRecomm
      // this.brokerOrModelForPortfolio = localStorage.getItem(
      //   "BrokerOrModelForPortfolio"
      // );
      this.brokerOrModelForPortfolio = this.portfolio.BrokerOrModelForPortfolio;

      // Initial Cash Percentage
      this.initCashPct =
        (this.rankingLastRow["Init_cash"] / this.rankingLastRow["Port_value"]) *
        100;

      // Final Cash Percentage
      var recCashRow = _.find(this.recommData, function(obj) {
        return obj.Symbol == "LIQUIDBEES";
      });
      this.finalCashPct = recCashRow && recCashRow["Weightage"];

      /*Charts Section Starts*/

      //Bar Charts - Horizontal Bar Chart Data:
      this.setBarData(this.portfolioData); // Top Holdings for Existing Portfolio
      if(this.recommData){
        this.setBarDataForModel(this.recommData); // Top Holdings for Model Portfolio
      }

      // Pie Charts
      this.setPieData(); //Pie Chart Data
      if(this.is_premium==1){
        this.setPieDataForModel(); //Pie Chart Data
      }
      if(this.sectorBreakdown){
        this.setPieDataForTop5User(this.sectorBreakdown); //Pie Chart Data
        this.setPieDataForTop5Model(this.sectorBreakdown); //Pie Chart Data
      }

      // Stacked Bar Charts
      this.setInitStackedBar();
      this.setFinalStackedBar();

      /*Charts Section Ends*/

      /* Banking */
      this.bankingRow = _.some(this.portfolioData, { Template: "Banking" });
      var temp = this;
      JSON.parse(localStorage.getItem("autoDownloadReport"))==true &&temp.setTab("pdf");
      localStorage.removeItem("autoDownloadReport");
    } else {
      this.$toastr.e("Invalid Object, Please try again");
      // this.$router.push(this.$route.query.redirect || "/ImportHoldings")
      this.$router.push({
        name: "ImportHoldings"
      });
    }
  },

  methods: {
    ...mapActions("addholdings", {
      setEnableReport: "setEnableReport",
      setTransactionData: "setTransactionData"
    }),

    ...mapActions("portfolioreport", {
      setTab: "setTab"
    }),

    setBarData(arrays) {
      /****Usage
         1.Sector Analysis & Style Diversification:Top 10 holdings
         2.Existing Vs Restructured Portfolio: Top 10 Holdings for Existing Portfolio****/
      var cashObj = { Weightage: this.initCashPct, Name: "Cash" };
      var barDatasize = Object.keys(arrays).length;
      arrays[barDatasize] = cashObj;
      this.barData.datasets[0].data = this.getTwoFixedArr(
        _.map(_.orderBy(arrays, "Weightage", "desc"), "Weightage").slice(
          0,
          this.limit
        )
      );
      this.barData.labels = _.map(
        _.orderBy(arrays, "Weightage", "desc"),
        "Name"
      ).slice(0, this.limit);
      delete arrays[barDatasize]; // Delete Newly Added Cash Index to Plot Bar Graph
      cashObj = {};
      this.filterZeros(this.barData.datasets[0].data, this.barData.labels);
      this.plotBarData = this.plotOrNot(this.barData.datasets[0].data);
    },

    setBarDataForModel(arrays) {
      //Used in Existing Vs Restructured Portfolio: Top 10 Holdings for Model Portfolio
      var finalCashObj = {
        Non_cash_weightage: this.finalCashPct,
        Name: "Cash"
      };
      var modelBarDatasize = Object.keys(arrays).length;
      arrays[modelBarDatasize] = finalCashObj;
      this.barDataForModel.datasets[0].data = this.getTwoFixedArr(
        _.map(
          _.orderBy(arrays, "Non_cash_weightage", "desc"),
          "Non_cash_weightage"
        ).slice(0, this.limit)
      );
      this.barDataForModel.labels = _.map(
        _.orderBy(arrays, "Non_cash_weightage", "desc"),
        "Name"
      ).slice(0, this.limit);
      delete arrays[modelBarDatasize]; // Delete Newly Added Final Cash Index to Plot Bar Graph
      finalCashObj = {};
      this.filterZeros(
        this.barDataForModel.datasets[0].data,
        this.barDataForModel.labels
      );
      this.plotBarDataForModel = this.plotOrNot(
        this.barDataForModel.datasets[0].data
      );
    },

    setPieData() {
      this.plotPieData = true;
      this.chartData.datasets[0].data = _.concat(
        this.getSum(this.sectorLarge),
        this.getSum(this.sectorMid),
        this.getSum(this.sectorSmall)
      );
      this.plotPieData = this.plotOrNot(this.chartData.datasets[0].data);
    },

    setPieDataForModel() {
      this.chartDataForModel.datasets[0].data = _.concat(
        this.getTwoFixedValWithZero(this.sectorDataForModel["Large"]),
        this.getTwoFixedValWithZero(this.sectorDataForModel["Mid"]),
        this.getTwoFixedValWithZero(this.sectorDataForModel["Small"])
      );
      this.plotPieDataForModel = this.plotOrNot(
        this.chartDataForModel.datasets[0].data
      );
    },

    setPieDataForTop5User(arrays) {
      this.chartDataForTop5User.datasets[0].data = this.getTwoFixedArr(
        _.map(
          _.orderBy(arrays, "pct_userPortfolio", "desc"),
          "pct_userPortfolio"
        ).slice(0, 5)
      );
      this.chartDataForTop5User.labels =
        _.map(
          _.orderBy(arrays, "pct_userPortfolio", "desc"),
          "SectorName"
        ).slice(0, 5)
      this.plotPieDataForTop5User = this.plotOrNot(
        this.chartDataForTop5User.datasets[0].data
      );
    },

    setPieDataForTop5Model(arrays) {
      this.chartDataForTop5Model.datasets[0].data = this.getTwoFixedArr(
        _.map(
          _.orderBy(arrays, "pct_modelPortfolio", "desc"),
          "pct_modelPortfolio"
        ).slice(0, 5)
      );
      this.chartDataForTop5Model.labels =
        _.map(
          _.orderBy(arrays, "pct_modelPortfolio", "desc"),
          "SectorName"
        ).slice(0, 5)
      this.plotPieDataForTop5Model = this.plotOrNot(
        this.chartDataForTop5Model.datasets[0].data
      );
    },

    setInitStackedBar() {
      this.stackedBarDataForInit.datasets[0].data[0] = this.getTwoFixedValWithZero(
        this.initCashPct
      );
      this.stackedBarDataForInit.datasets[1].data[0] = this.getTwoFixedValWithZero(
        100 - this.getTwoFixedValWithZero(this.initCashPct)
      );
    },

    setFinalStackedBar() {
      this.stackedBarDataForFinal.datasets[0].data[0] = this.getTwoFixedValWithZero(
        this.finalCashPct
      );
      this.stackedBarDataForFinal.datasets[1].data[0] = this.getTwoFixedValWithZero(
        100 - this.getTwoFixedValWithZero(this.finalCashPct)
      );
    },

    filterZeros(arrays, labels) {
      const list = [];
      arrays.map((value, index) => {
        if (value > 0) {
          list.push(value);
        } else {
          labels.splice(index);
        }
      });
      return list;
    },

    getUCfirst(arrays) {
      const list = [];
      arrays.map(value => {
        var firstLetter = value.substr(0, 1);
        list.push(firstLetter.toUpperCase() + value.substr(1).toLowerCase());
      });
      return list;
    },

    getUCfirstName(name) {
      return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
    },

    getTwoFixedArr(arrays) {
      const list = [];
      arrays.map(function(value) {
        list.push(parseFloat(value).toFixed(2));
      });
      return list;
    },

    getTwoFixedVal(value) {
      if (
        isNaN(value) ||
        value == 0 ||
        value == "-" ||
        value == null ||
        value == ""
      ) {
        return "-";
      } else {
        return parseFloat(value).toFixed(2);
      }
    },

    getTwoFixedValWithZero(value) {
      if (isNaN(value) || value == "-" || value == null || value == "") {
        value = 0;
      }
      return parseFloat(value).toFixed(2);
    },

    appendPercentage(arrays) {
      const list = [];
      arrays.map(function(value) {
        list.push(value.concat("%"));
      });
      return list;
    },

    getSum(array) {
      return _.reduce(
        array,
        function(memo, num) {
          return parseFloat(memo + num);
        },
        0
      ).toFixed(2);
    },

    plotOrNot(a) {
      var sum = a.reduce(function(a, b) {
        return parseFloat(a) + parseFloat(b);
      }, 0);
      if (sum > 0) {
        return true;
      } else {
        return false;
      }
    },

    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },

    getIntFormat(value) {
      if (
        isNaN(value) ||
        value == 0 ||
        value == "-" ||
        value == null ||
        value == ""
      ) {
        return "-";
      } else {
        return this.formatNumber(parseFloat(value).toFixed(2));
      }
    },

    logout(msg) {
      this.$router.push({ name: "Logout" });
      this.$toastr.e(msg);
    },

    newReport() {
      localStorage.removeItem("reEvaluatePortfolioData")
      localStorage.removeItem("preLoginHoldingsData");
      window.location.reload()
    },

    generatePdf() {
      this.setTab("pdf");
    },

    customFilter(val) {
      return "Unsafe String...";
    },

    onCancel() {
      this.$toastr.e("User cancelled the loader..");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/PortfolioReport.vue